import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import axios from "../../../../helpers/axios";
import {getSearchParam} from "../../components/getSearchParam";
import {Portlet, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import SearchForm from "../../components/searchForm";
import {Helmet} from "react-helmet";
import {Form} from "react-bootstrap";
import sayError from "../../../../helpers/sayError";
import IssuedGroupedTable, {prepareGroupedTable} from "../../components/issuedGroupedTable";

const OneByGrouped = () => {
  const { search } = useLocation();
  const [data, setData] = useState()
  const [withNds, setWithNds] = useState(false)

  useEffect(() => {
    if(search){
      axios.post('/api/racoon/pdfParse/incomeReport/one',{
        ...getSearchParam(search),
        groupBySupplier: true
      }).then(({data})=>{
        setData(prepareGroupedTable(data.table))
      }).catch(sayError)
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>Подробный доход</title>
      </Helmet>
      <Portlet>
        <PortletHeader title={<div className={'d-flex gap-2 align-items-center'}>
          <h5>Подробно</h5>
          <Form.Label className={'d-flex align-items-center gap-2 mb-2'}>
            <input
              defaultChecked={withNds}
              checked={withNds}
              onChange={(e) => {
                setWithNds(!withNds)
              }}
              type={"checkbox"}
            />{" "}
            НДС
          </Form.Label>
        </div>} toolbar={<PortletHeaderToolbar>
          <SearchForm one
                      grouped
                      cb={(data, search)=>{
                        setData(prepareGroupedTable(data.table))
                        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname +
                          `?start=${search.start}&end=${search.end}&id=${search.counterparty}`;
                        window.history.pushState({path:newurl},'',newurl)
                      }}
                      url={'/api/racoon/pdfParse/incomeReport/one'}/>
        </PortletHeaderToolbar>}/>
        <IssuedGroupedTable data={data} withNds={withNds}/>
      </Portlet>
    </>

  );
};

export default OneByGrouped;
